import Vue from 'vue'
import VueRouter from 'vue-router'
import AOS from 'aos'
import 'aos/dist/aos.css'
import App from './App.vue'
import './styles.css'
import lazyBg from './lazyBg'

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.directive('lazy-bg', lazyBg)

const routes = [{
		path: '/',
		component: () => import('./views/Home.vue'),
		meta: {
			title: '首页 - 合肥中科厚生医疗科技有限公司',
			description: '合肥中科厚生医疗科技有限公司官网首页，专注智慧医疗设备研发生产，提供医疗器械、医疗信息化及健康管理解决方案。',
			keywords: '合肥中科厚生,中科厚生官网,医疗科技公司,智慧医疗,医疗器械,医疗设备'
		}
	},
	{
		path: '/about',
		component: () => import('./views/ListPage.vue'),
		props: {
			type: 'about',
			title: '关于我们'
		},
		meta: {
			title: '关于我们 - 合肥中科厚生医疗科技有限公司',
			description: '了解合肥中科厚生医疗科技有限公司的发展历程、企业文化和核心团队，致力于成为智慧医疗领域的领先企业。',
			keywords: '关于中科厚生,医疗科技公司介绍,合肥医疗企业,中科厚生简介,企业文化,医疗公司资质'
		}
	},
	{
		path: '/products',
		component: () => import('./views/ListPage.vue'),
		props: {
			type: 'product',
			title: '产品中心'
		},
		meta: {
			title: '产品中心 - 合肥中科厚生医疗科技有限公司',
			description: '合肥中科厚生医疗科技产品中心，展示公司全系列智慧医疗设备、医疗器械产品及医疗信息化解决方案。',
			keywords: '医疗设备产品,医疗器械产品,智慧医疗设备,医疗信息化产品,医疗产品展示,中科厚生产品'
		}
	},
	{
		path: '/solutions',
		component: () => import('./views/ListPage.vue'),
		props: {
			type: 'solution',
			title: '解决方案'
		},
		meta: {
			title: '解决方案 - 合肥中科厚生医疗科技有限公司',
			description: '合肥中科厚生医疗科技为医院和医疗机构提供全方位的智慧医疗解决方案，涵盖医疗信息化、智能诊断和健康管理。',
			keywords: '医疗解决方案,智慧医疗方案,医院信息化方案,智能诊断方案,健康管理方案,数字医疗方案'
		}
	},
	{
		path: '/news',
		component: () => import('./views/ListPage.vue'),
		props: {
			type: 'news',
			title: '新闻资讯'
		},
		meta: {
			title: '新闻资讯 - 合肥中科厚生医疗科技有限公司',
			description: '合肥中科厚生医疗科技最新动态、行业资讯、医疗科技前沿报道及公司重大新闻。',
			keywords: '医疗科技新闻,医疗行业资讯,中科厚生动态,医疗公司新闻,医疗科技动态,医疗器械资讯'
		}
	},
	{
		path: '/support',
		component: () => import('./views/ListPage.vue'),
		props: {
			type: 'support',
			title: '服务支持'
		},
		meta: {
			title: '服务支持 - 合肥中科厚生医疗科技有限公司',
			description: '合肥中科厚生医疗科技为客户提供全面的售后服务、技术支持和设备维护服务，保障医疗设备稳定运行。',
			keywords: '医疗服务支持,医疗设备维护,医疗技术支持,售后服务,设备维修,医疗器械服务'
		}
	},
	{
		path: '/contact',
		component: () => import('./views/Contact.vue'),
		meta: {
			title: '联系我们 - 合肥中科厚生医疗科技有限公司',
			description: '联系合肥中科厚生医疗科技有限公司，获取产品咨询、技术支持或合作洽谈，我们竭诚为您服务。',
			keywords: '联系中科厚生,医疗公司联系方式,合肥医疗公司地址,医疗合作咨询,中科厚生电话'
		}
	},
	{
		path: '/detail/:id',
		component: () => import('./views/Detail.vue'),
		meta: {
			title: '详情 - 合肥中科厚生医疗科技有限公司',
			description: '合肥中科厚生医疗科技有限公司内容详情页，了解产品、新闻和解决方案的详细信息。',
			keywords: '中科厚生详情,医疗产品详情,医疗新闻详情'
		}
	}
]

const router = new VueRouter({
	mode: 'history',
	routes,
	scrollBehavior: () => ({
		x: 0,
		y: 0
	})
})

// 忽略重复导航到同一路径的错误（搜索框重复搜索等场景）
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => {
		if (err.name !== 'NavigationDuplicated') throw err
	})
}

// 更新 meta 标签的辅助函数
function updateMeta(name, content) {
	let meta = document.querySelector('meta[name="' + name + '"]')
	if (!meta) {
		meta = document.createElement('meta')
		meta.setAttribute('name', name)
		document.head.appendChild(meta)
	}
	meta.setAttribute('content', content || '')
}

router.afterEach(to => {
	// 更新标题
	if (to.meta && to.meta.title) {
		document.title = to.meta.title
	}
	// 更新描述
	if (to.meta && to.meta.description) {
		updateMeta('description', to.meta.description)
	}
	// 更新关键词
	if (to.meta && to.meta.keywords) {
		updateMeta('keywords', to.meta.keywords)
	}
	setTimeout(() => AOS.refresh(), 80)
})

new Vue({
	router,
	mounted() {
		AOS.init({
			easing: 'ease-out-back',
			duration: 1000,
			once: false
		})
	},
	render: h => h(App)
}).$mount('#app')